const tablesAndFilters = {
    setFilterByOrderId: 'Check notifications with current order ID by click',
  };
  
export default tablesAndFilters;
 